import { useState, useEffect, React } from "react";
import { useDispatch, useSelector } from "react-redux";
import api from "../../utils/api";
// import { StarIcon } from "@material-ui/icons/Star";
import { useParams } from "react-router-dom";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import CallIcon from "@mui/icons-material/Call";
import HomeIcon from "@mui/icons-material/Home";
import CategoryIcon from "@mui/icons-material/Category";
import StarIcon from "@mui/icons-material/Star";
const CompletedFypDetails = () => {
  const [FYP, setFYP] = useState({});
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  const params = useParams();

  useEffect(() => {
    api
      .get(`/FYPs/by-id/${params?.fypId}`)
      .then((res) => {
        console.log("FYP>", res.data);
        setFYP(res.data);
      })
      .catch((err) => console.log(err));
  }, []);
  const [rating, setRating] = useState(0);
  const navigate = useNavigate();

  const deleteFYP = (h) => {
    console.log("FYP", FYP);
    api
      .delete(`/FYPs/${h?._id}`)
      .then((res) => {
        if (res.data) {
          let notifBody = {
            userId: currentUser?.id,
            text: `Admin delete your FYP for violating terms and conditions.`,
            forAll: false,
            receiverId: h?.userId,
          };
          api
            .post("/notifications", notifBody)
            .then((re) => console.log("notif", re.data));
          window.location.reload();
        }
      })
      .catch((err) => console.log);
  };
  return (
    <Box className="container">
      <Box>
        <Typography
          variant="h4"
          sx={{ fontWeight: "600", color: "fontPrimaryColor.main" }}
        >
          {FYP?.title}
        </Typography>
      </Box>
      <Box sx={{ width: { md: "70%", xs: "90%" } }}>
        <Carousel>
          {FYP?.projectImages?.map((slideImage, index) => (
            <Box key={index} sx={{ marginTop: "30px" }}>
              <img src={slideImage} style={{ width: "100%", height: "auto" }} />
            </Box>
          ))}
        </Carousel>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {/* <Box sx={{ display: "flex", gap: "15px" }}>
          <Typography
            variant="body2"
            sx={{ fontWeight: "600", width: "120px" }}
          >
            <CallIcon /> Contact No.{" "}
          </Typography>
          <Typography variant="body" sx={{ color: "colorThree.main" }}>
            {hostel?.generalData?.contact}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: "15px" }}>
          <Typography
            variant="body2"
            sx={{ fontWeight: "600", width: "120px" }}
          >
            <HomeIcon /> Address{" "}
          </Typography>
          <Typography variant="body" sx={{ color: "colorThree.main" }}>
            {hostel?.generalData?.hostelAddress}
          </Typography>
        </Box> */}
      </Box>
      {/* <Box
        className="row"
        sx={{
          borderTop: "1px dashed lightgray",
          borderBottom: "1px dashed lightgray",
          margin: "30px 0",
          display: "flex",
          padding: "20px ",
        }}
      > */}
      {/* <Box sx={{ display: "flex", flex: "0.5", gap: "5px" }}>
          {" "}
          <Box>
            <CategoryIcon sx={{ fontSize: "2rem", color: "colorThree.main" }} />
          </Box>
          <Box>
            <Typography sx={{ fontSize: "0.8rem", color: "#0c0c0c" }}>
              Project Type
            </Typography>
            <Typography>{FYP?.projectType}</Typography>
          </Box>
        </Box> */}
      {/* </Box> */}
      <Box
        sx={{
          marginTop: "20px",
          borderTop: "1px dashed lightgray",
          padding: "30px 0",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <Box sx={{ display: "flex" }}>
          <Typography sx={{ flex: "0.3", fontWeight: "600" }}>
            Project Type
          </Typography>
          <Typography sx={{ flex: "0.3" }}>{FYP?.projectType}</Typography>
        </Box>
        <Box sx={{ display: "flex" }}>
          <Typography sx={{ flex: "0.3", fontWeight: "600" }}>
            Technology
          </Typography>
          <Typography sx={{ flex: "0.3" }}>{FYP?.techUsed}</Typography>
        </Box>
        <Box sx={{ display: "flex" }}>
          <Typography sx={{ flex: "0.3", fontWeight: "600" }}>
            Supervisor
          </Typography>
          <Typography sx={{ flex: "0.3" }}>{FYP?.supervisor}</Typography>
        </Box>
        <Box sx={{ display: "flex" }}>
          <Typography sx={{ flex: "0.3", fontWeight: "600" }}>
            Co Supervisor
          </Typography>
          <Typography sx={{ flex: "0.3" }}>
            {FYP?.coSupervisor ? FYP?.coSupervisor : "N/A"}
          </Typography>
        </Box>
        <Box sx={{ display: "flex" }}>
          <Typography sx={{ flex: "0.3", fontWeight: "600" }}>
            Date of Completion
          </Typography>
          <Typography sx={{ flex: "0.3" }}>{FYP?.completionDate}</Typography>
        </Box>

        <Box sx={{ display: "flex" }}>
          <Typography sx={{ flex: "0.3", fontWeight: "600" }}>
            Project Link
          </Typography>
          <Typography sx={{ flex: "0.3" }}>
            {FYP?.projectLink ? (
              <>
                {" "}
                <a href={FYP?.projectLink}>{FYP?.projectLink}</a>
              </>
            ) : (
              <>N/A</>
            )}
          </Typography>
        </Box>
        <Box sx={{ display: "flex" }}>
          <Typography sx={{ flex: "0.3", fontWeight: "600" }}>
            Participent Names
          </Typography>
          <Box sx={{ marginLeft: "60px" }}>
            {FYP?.participentsNames?.map((p) => (
              <Box>
                <Typography sx={{ flex: "0.3" }}>{p}</Typography>
              </Box>
            ))}
          </Box>
        </Box>
        <Box sx={{ display: "flex" }}>
          <Typography sx={{ flex: "0.3", fontWeight: "600" }}>
            Project Files
          </Typography>
          {FYP?.projectFileUrl ? (
            <Typography sx={{ flex: "0.3" }}>
              <a href={FYP?.projectFileUrl}>Open the Link</a>
            </Typography>
          ) : (
            "N/A"
          )}
        </Box>
      </Box>
      <Box sx={{ marginTop: "20px" }}>
        <Typography
          variant="h5"
          sx={{ fontWeight: "600", marginBottom: "10px" }}
        >
          Description
        </Typography>
        <Typography
          variant="p"
          sx={{ marginTop: "15px", color: "fontPrimaryColor.main" }}
        >
          {FYP?.description}
        </Typography>
      </Box>

      <Box sx={{ marginTop: "30px" }}>
        {currentUser?.isAdmin ? (
          <button
            className=" asc__submit__form__button"
            onClick={() => deleteFYP(FYP)}
          >
            Delete FYP
          </button>
        ) : (
          <></>
        )}
      </Box>
    </Box>
  );
};

export default CompletedFypDetails;
